import { useCallback, useSyncExternalStore } from 'react';
import { getLocalePrefs, subscribeLocalePrefs } from '@/lib/locale';
import { t, type MessageKey } from './t';

type Vars = Record<string, string | number>;

/** Hook: re-renderiza quando o idioma da UI muda. */
export function useT() {
  const uiLocale = useSyncExternalStore(
    subscribeLocalePrefs,
    () => getLocalePrefs().uiLocale,
    () => 'pt-BR' as const,
  );

  return useCallback(
    (key: MessageKey, vars?: Vars) => t(key, vars, uiLocale),
    [uiLocale],
  );
}
